import { observer } from 'mobx-react';
import * as React from 'react';
import { DefaultSelect } from '../default-select';
import { fieldLabel } from '../../../core/labels';
import { injectTSDI } from '../../../core/tsdi';
import { OptionsStore } from '../../../core/options';
import { WrappedField } from '../../../core/forms';
import { FieldGroup } from '../group';

import './default-date-field.scss';

interface DefaultDateFieldProps {
    dayField: WrappedField<string>;
    monthField: WrappedField<string>;
    yearField: WrappedField<string>;
    className?: string;
}

export const DefaultDateField = observer((props: DefaultDateFieldProps) => {
    const { dayOptions, yearOptions, monthOptions } = injectTSDI(OptionsStore);

    const { className, dayField, monthField, yearField } = props;

    return (
        <FieldGroup className={classnames(className, 'field-date')}>
            <DefaultSelect
                field={dayField}
                options={dayOptions}
                label={fieldLabel('day')}
                data-role="date-of-birth-day"
            />
            <DefaultSelect
                field={monthField}
                options={monthOptions}
                label={fieldLabel('month')}
                data-role="date-of-birth-month"
            />
            <DefaultSelect
                field={yearField}
                options={yearOptions}
                label={fieldLabel('year')}
                data-role="date-of-birth-year"
            />
        </FieldGroup>
    );
});
